module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-b-0622.761c029f.jpg";